var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.594,
    height: 21,
    viewBox: "0 0 27.594 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-623 -72.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1270",
    "data-name": "Trac\\xE9 1270",
    d: "M647.226,72.75H626.374A3.377,3.377,0,0,0,623,76.124V90.375a3.377,3.377,0,0,0,3.374,3.374H647.22a3.377,3.377,0,0,0,3.374-3.374V76.13A3.374,3.374,0,0,0,647.226,72.75Zm0,19.458H626.374a1.835,1.835,0,0,1-1.833-1.833V76.13a1.835,1.835,0,0,1,1.833-1.833H647.22a1.835,1.835,0,0,1,1.833,1.833V90.375h.006A1.835,1.835,0,0,1,647.226,92.208Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1271",
    "data-name": "Trac\\xE9 1271",
    d: "M692.972,131.3l6.749-6.052a.772.772,0,1,0-1.033-1.148l-9.307,8.353-1.816-1.622c-.006-.006-.011-.011-.011-.017a1.137,1.137,0,0,0-.126-.108L680.04,124.1a.772.772,0,1,0-1.028,1.153l6.829,6.1-6.8,6.366a.774.774,0,0,0-.034,1.091.789.789,0,0,0,.565.246.773.773,0,0,0,.525-.206L687,132.4l1.873,1.673a.769.769,0,0,0,1.028-.006l1.924-1.724,6.863,6.52a.773.773,0,0,0,1.091-.029.774.774,0,0,0-.029-1.091Z",
    transform: "translate(-52.569 -48.232)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhite);
export default __webpack_public_path__ + "static/media/mail-white.9864915e0cbb6148a62dace7420b9233.svg";
export { ForwardRef as ReactComponent };